import React from 'react';
import PropTypes from 'prop-types';

import Styles from './Table.module.scss';

/** Notice: this component has some inline styling.
 *  This is so in order to have it be capable of dynamic width.
 */
export default function Table({ headers, rows, width, tableKey }) {
  const { Table, First } = Styles;

  /** Curb function turns strings into <p>s.
   *  Simple logic that I'd rather be absent from the JSX structure.
   */
  const Curb = elem =>
    typeof elem === 'string' ? (
      <p>
        {`${elem.substr(0, 1)}${elem.substr(elem.length - 1, 1)}` === '[]'
          ? JSON.parse(elem).join(', ')
          : elem}
      </p>
    ) : (
      elem
    );

  let headerCount = 0;
  let rowCount = 0;
  let dCount = 0;

  return (
    <table className={Table}>
      <tbody>
        <tr>
          {headers.map((header, index) => (
            <th
              key={`${tableKey}_header${headerCount++}`}
              style={{ textAlign: !index && 'left', width: `${width}%` }}
            >
              {header}
            </th>
          ))}
        </tr>
        {rows.map(row => (
          <tr key={`${tableKey}_row${rowCount++}`}>
            {row.map((elem, index) => (
              <td
                key={`${tableKey}_d${dCount++}`}
                className={!index ? First : undefined}
              >
                {Curb(elem)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

Table.defaultProps = {
  width: 70,
};

Table.propTypes = {
  tableKey: PropTypes.string.isRequired,
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  rows: PropTypes.arrayOf(PropTypes.any).isRequired,
  width: PropTypes.number,
};
